import React, { useEffect } from 'react'
import Header from '../../../headerone/Main'
import Bredcom from '../../../Bredcom/Main'
import FamilyAssistanceApplication from '../../menforms/form/FamilyAssistanceApp'
// import Mayor from '../../menhome/Mayor'
// import Second from '../../menhome/Client'

function Main() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Family Assistance Application || Forms";
  }, [])

  return (
    <>
        {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

        <div className="page-wrapper">
          <Bredcom 
            subtitle="Forms"
            title="Family Assistance Application"
            subtitledown="Family Assistance Application"
           />
            <FamilyAssistanceApplication/>
            {/* <Mayor/>
            <Second/> */}
        </div>
    </>
  )
}

export default Main